import {
    CLEAR_CREATE_DRAW,
    CREATE_DRAW, DELETE_CREATE_DRAW,
    FETCH_CREATE_DRAW,
    LIST_CREATE_DRAW,
    MODIFIED_CREATE_DRAW
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    list: [],
    page: 1,
    size: 10,
    totals: 0
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_CREATE_DRAW:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_CREATE_DRAW:
            return {
                ...state,
                isLoading: false,
                list: payload,
            };
        case CREATE_DRAW:
            return {
                ...state,
                isLoading: true,
                list: [],
            };
        case CLEAR_CREATE_DRAW:
            return {
                ...state,
                list: [],
            };
        case DELETE_CREATE_DRAW:
        case MODIFIED_CREATE_DRAW:
            return {
                ...state,
                isLoading: true
            };
        default:
            return state;
    }
}